<body class="gray-bg">
  <div class="middle-box text-center animated fadeInDown">
    <h1>404</h1>
    <h3 class="font-bold">Page Not Found</h3>
    <div class="error-desc m-b">
      Sorry, but the page you are looking for was not found. Try checking the URL for error, then hit the refresh button on your browser or try to find something else in our
      application. <br />
    </div>
    <shared-ui-buttons-button [type]="buttonType.Primary" [text]="'Home'" (action)="navigateBack()"></shared-ui-buttons-button>
  </div>
</body>
